import { Label } from "../Label/Label";
import { ModalPopup } from "../ModalPopup/ModalPopup";
import { Popup } from "../Popup/Popup";
import styles from "./ConfirmationPopup.module.css";

interface ConfirmationPopupProps {
  id: string;
  title: string;
  description?: string;
  priority?: boolean;
  destructive?: boolean;
  onConfirmClicked: () => void;
}

export const ConfirmationPopup = (props: ConfirmationPopupProps) => {
  return (
    <ModalPopup
      id={props.id}
      title={props.title}
      onActionClicked={() => {
        Popup.remove(props.id);
        props.onConfirmClicked();
      }}
      containerProps={{ topMargin: "50px", maxWidth: "50%" }}
      actionButtonType={props.destructive ? "danger" : "primary"}
      children={
        <div className={styles.container}>
          <Label type="paragraph" className={styles.body} text={props.description ?? ""} />
        </div>
      }
    />
  );
};

